import * as React from "react";

import { cn } from "../../../utils";

export type TTextAreaAdditionalProps = {
  rows: number;
};
export type TTextAreaProps = React.InputHTMLAttributes<HTMLTextAreaElement> &
  TTextAreaAdditionalProps;

const TextArea = React.forwardRef<HTMLTextAreaElement, TTextAreaProps>(
  ({ rows, className, type, ...props }, ref) => {
    return (
      <textarea
        rows={rows}
        className={cn(
          "w-full rounded-md px-4 py-2 border hover:border-border-hover text-sm bg-background common-input-focus",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
TextArea.displayName = "TextArea";

export { TextArea };
